import { useHistory } from "react-router-dom/cjs/react-router-dom"
import { ArrowBack } from "@mui/icons-material"
import { Box, Button } from "@mui/material"
import { TemplatesList } from "./TemplatesList"

export const Attract = () => {
    const history = useHistory()

    const backHandler = () => {
        history.push('/campaign/sales_page?type=property')
    }
    return (
        <Box height="100%" width="100%" display="flex" flexDirection="column">
            <Box display="flex" alignItems="center">
                <Box display="flex" onClick={()=> backHandler()} component={Button} gap="8px" fontSize={14} color="#333" borderRadius={2} minWidth={0} sx={{ ':hover': { color: '#333' } }}>
                    <ArrowBack sx={{ color: '#009F4D', fontSize: 22 }} />
                   <Box fontSize={20} fontWeight={600}>Back</Box>
                </Box>
            </Box>
            <TemplatesList />
        </Box>
    )
}
